import { render, staticRenderFns } from "./access_without_code.vue?vue&type=template&id=0a4351b8&scoped=true"
import script from "./access_without_code.vue?vue&type=script&lang=js"
export * from "./access_without_code.vue?vue&type=script&lang=js"
import style0 from "./access_without_code.vue?vue&type=style&index=0&id=0a4351b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4351b8",
  null
  
)

export default component.exports